import {
  UPDATE_ENTERPRISE,
  UPDATE_ENTERPRISE_SUCCESS,
  UPDATE_ENTERPRISE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateEnterpriseReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ENTERPRISE:
      return { ...state, loading: true };
    case UPDATE_ENTERPRISE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_ENTERPRISE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateEnterpriseReducer;
